import { useNavigate } from "react-router-dom";

interface ItemResourceProps {
    id: string;
    title: string;
    color: string;
    pictureUrl?: string;
}

const ResourceGridItem: React.FC<ItemResourceProps> = ({ id, title, color, pictureUrl }) => {
    const navigate = useNavigate();

    return (
        <div className="max-w-40 w-full flex flex-col gap-1 cursor-pointer h-full justify-between" onClick={() => navigate(`/career/resource/${id}`)}>
            {pictureUrl
                ? <img
                    src={pictureUrl}
                    alt={title}
                    className="w-full aspect-square object-cover rounded-[15px] border-5"
                    style={{
                        borderColor: color,
                    }}
                />
                : <div
                    className="w-full aspect-square bg-gray-300 rounded-[15px] border-5"
                    style={{
                        borderColor: color,
                    }}
                />
            }
            <div className="w-full flex items-center justify-center min-h-16">
                <p className="text-xs font-bold line-clamp-4" style={{ color: color }}>{title}</p>
            </div>
        </div>
    );
};

export default ResourceGridItem;
